/*
  提交按钮的loading控制
*/
import { mapState, mapMutations } from 'vuex';
export const btLoading = {
  computed: {
    ...mapState({
      btLoading: state => state.loading.btLoading
    })
  },
  methods: {
    ...mapMutations(['SET_BTLOADING'])
  },
  created() {
    this.SET_BTLOADING(false);
  }
};
